import {ServerResponse} from "http";

import * as Sentry from "@sentry/nextjs";

export const redirectToLowercase = (asPath: string, res: ServerResponse): void => {
  try {
    const [path, query] = asPath.split("?");

    if (path !== path.toLowerCase()) {
      const location = query ? `${path.toLowerCase()}?${query}` : path.toLowerCase();

      res.writeHead(308, {Location: location});
      res.end();
    }
  } catch (e) {
    Sentry.captureException(e);
  }
};
